import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import { createBrowserHistory } from 'history';
import reducers from './reducers';

export const history = createBrowserHistory();

const config = {
  key: 'cloudchefs-delivery',
  whitelist: ['app', 'auth'],
  storage,
};

const persistedReducer = persistReducer(config, reducers);

export const store = createStore(
  connectRouter(history)(persistedReducer),
  {},
  compose(
    applyMiddleware(thunkMiddleware),
    applyMiddleware(routerMiddleware(history)),
    (typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined') ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  ),
);

export const persistor = persistStore(store);

history.listen(() => {
  window.scrollTo(0, 0);
});